import React, { Component } from 'react';
import '../styles/Modelo.css';
import Banner from './Banner'
import modeloBanner from '../images/modelo/banner.png'
import infoModeloImg from '../images/modelo/infografia.png'

import aduanaIcon from '../icons/modelo/aduana.svg'
import apmIcon from '../icons/modelo/apm.svg'
import clienteIcon from '../icons/modelo/cliente.svg'
import depositoIcon from '../icons/modelo/deposito.svg'
import globalIcon from '../icons/modelo/global.svg'
import laboratorioIcon from '../icons/modelo/laboratorios.svg'
import plantaIcon from '../icons/modelo/planta.svg'
import ScrollTop from './ScrollTop'
import Analytics from './Analytics'

class Modelo extends Component {
    render(){
        return(
            <div className="Modelo">
                <ScrollTop />
                <Analytics />
                <div class="modelo-container">
                    <Banner className="modelo-banner" imageBanner={modeloBanner} title="Nuestro modelo de negocio"
                     description="Somos el departamento comercial y logístico de prestigiosas empresas."/>
                     <div class="modelo-content">
                        <img src={infoModeloImg} class="modelo-info-img"/>
                        <div class="modelo-content-responsive">
                            <div class="aduana-modelo">
                                <h4>ADUANA</h4>
                                <img src={aduanaIcon} />
                            </div>
                            <div class="lab-modelo">
                                <img src={laboratorioIcon} />
                                <div class="lab-modelo-text-container">
                                    <h4>LABORATORIOS</h4>
                                    <ul>
                                        <li>Condiciones comerciales</li>
                                        <li>Cobranzas</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="aduana-modelo">
                                <h4>PLANTA DE PRODUCCIÓN</h4>
                                <img src={plantaIcon} />
                            </div>
                            <div class="global-modelo">
                                <img src={globalIcon} />
                                <div class="global-modelo-text-container">
                                    <ul>
                                        <li>Campaña</li>
                                        <p>Material promocional</p>
                                        <li>Entrega MM y MP</li>
                                        <p>Muestras médicas</p>
                                    </ul>
                                </div>
                            </div>
                            <div class="aduana-modelo">
                                <h4>APMs</h4>
                                <img src={apmIcon} />
                            </div>
                            <div class="deposito-modelo">
                                <img src={depositoIcon} />
                                <div class="deposito-modelo-text-container">
                                    <h4>DEPÓSITO</h4>
                                    <p>OPERADOR LOGÍSTICO</p>
                                    <ul>
                                        <li>Facturación</li>
                                        <li>Órdenes de despacho</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="devol-modelo">
                                <h5>Devoluciones</h5>
                            </div>
                            <div class="cliente-modelo">
                                <img src={clienteIcon} />
                                <div class="cliente-modelo-text-container">
                                    <h4>CLIENTE</h4>
                                    <ul>
                                        <li>Pedidos</li>
                                        <li>Cobranzas</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                     </div>
                </div>
            </div>
        )
    }
    
}

export default Modelo


// WEBPACK FOOTER //
// ./src/components/Modelo.js